import React, { useEffect } from 'react';
import { withSnackbar, WithSnackbarProps, useSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Variants } from '../Variants.enum';

interface SGToastsProps extends WithSnackbarProps {
    content: string;
    variant: Variants | any;
    dismissed: boolean;
    enqueueSnackbar: any;
    closeSnackbar: any;
}

const styles = {
    success: {
        backgroundColor: '#0000ff',
    },
    error: {
        backgroundColor: '#d32f2f',
    },
    info: {
        backgroundColor: '#2979ff',
    },
    warning: {
        backgroundColor: '#ffa000',
    },
};

export const Toasts = (props: SGToastsProps) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        enqueueSnackbar(props.content, {
            variant: props.variant || Variants.default,
            autoHideDuration: 7000,
            action: (key: string | number | undefined) => (
                <IconButton
                    style={{ color: '#020250', borderRadius: '50%', padding: '4px' }}
                    size="small"
                    onClick={() => {
                        closeSnackbar(key);
                        props.dismissed = true;
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ),
        });
    }, []);

    useEffect(
        () => () => {
            closeSnackbar();
            props.dismissed = true;
        },
        []
    );

    return <></>;
};

export default withStyles(styles)(withSnackbar(Toasts));
